import React, { useContext } from "react";
import "./LoginCredentail.css";
import InputText from "../../../../../components/TextComponent/textInput";
import Button from "../../../../../components/ButtonComponent/Button";
import { LoginCredentailsContext } from "../LoginCredentailView";
import AlertBox from "../../../../../components/alertComponent/AlertBox";
import Spinner from "../../../../../components/spinner/Spinner";

const LoginCredentails = ({ textContents }) => {
  const {
    loginCredentailsSubmit,
    setUserID,
    setPassword,
    userId,
    password,
    showAlert,
    setShowAlert,
    alertMessage,
    apiStatus
  } = useContext(LoginCredentailsContext);
  
  return (
    <div className="userContain">
      <div className="loginContainer">
        <div className="col-xl-4 col-lg-5 col-md-5 col-sm-6 col-10 mainBoxEnterOtp">
          { apiStatus === 'fetching'  ? <Spinner /> : null}
          <div className="userIdText">{textContents.userId}</div>
          <div className="userIdInput">
            <InputText
              type="text"
              placeholder={textContents.enterUserId}
              value={userId}
              onChange={(e) => {
                setUserID(e.target.value);
              }}
            />
          </div>
          <div className="userIdText">{textContents.password}</div>
          <div className="userIdInput">
            <InputText
              type={"password"}
              placeholder={textContents.enterpassword}
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
              }}
            />
          </div>

          <div className="credentialSubmit">
            <Button
              onClick={loginCredentailsSubmit}
              text={textContents.submit}
            />
          </div>
        </div>
      </div>
      <AlertBox
        show={showAlert}
        setShow={setShowAlert}
        title={textContents.alert}
        alertMessage={alertMessage}
      />
    </div>
  );
};
export default LoginCredentails;
